import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  it: {
    meta: {
      title: "Forte Servizii SRLS | Partner Affidabile per l'Edilizia e la Prefabbricazione",
    },
    nav: {
      tagline: "SRLS · IMPRESA EDILE",
      status: "Operatività cantieri attiva",
      quote: "Preventivo",
      quoteMobile: "Richiedi un Preventivo",
      links: [
        { id: "#chi-siamo", label: "Chi Siamo", testid: "nav-link-chi-siamo" },
        { id: "#servizi", label: "Servizi", testid: "nav-link-servizi" },
        { id: "#perche-sceglierci", label: "Perché Noi", testid: "nav-link-perche-sceglierci" },
        { id: "#contatti", label: "Contatti", testid: "nav-link-contatti" },
      ],
    },
    hero: {
      badge: "IMPRESA EDILE SPECIALIZZATA · B2B",
      lines: [
        { before: "Partner ", accent: "Affidabile", after: "" },
        { before: "per l'Edilizia", accent: "", after: "" },
        { before: "e la Prefabbricazione", accent: "", after: "" },
      ],
      subtitle:
        "Serietà, sicurezza sul lavoro e manovalanza qualificata: supportiamo general contractor, imprese edili e stabilimenti di prefabbricazione con squadre operative specializzate.",
      ctaQuote: "Richiedi un Preventivo",
      ctaContact: "Contattaci",
      stats: [
        { value: "D.Lgs 81/08", label: "Conformità totale sicurezza" },
        { value: "B2B", label: "Focus esclusivo su imprese" },
        { value: "< 24h", label: "Risposta ai preventivi" },
      ],
      scrollAria: "Scorri alla sezione Chi Siamo",
      imgAlt: "Armatura di una galleria in cemento armato realizzata da Forte Servizii",
    },
    marquee: {
      items: [
        "Carpenteria Strutturale",
        "Posa Ferro Cemento Armato",
        "Outsourcing Prefabbricazione",
        "Personale Specializzato",
        "Sicurezza Certificata",
        "Tempi di Consegna Garantiti",
      ],
    },
    about: {
      overline: "Chi Siamo",
      title: "Solidità operativa, mentalità da cantiere",
      p1: "è una realtà solida, dinamica e flessibile, specializzata nel supporto operativo a cantieri e stabilimenti produttivi. Lavoriamo fianco a fianco con general contractor e imprese edili, integrandoci nei loro processi e ottimizzando i tempi di lavorazione.",
      p2: "Dalla carpenteria alla posa del ferro, ogni intervento è eseguito da personale selezionato e formato, con un'attenzione assoluta alla sicurezza e al rispetto dei cronoprogrammi di commessa.",
      stats: [
        { value: "100%", label: "Rispetto delle normative di sicurezza" },
        { value: "B2B", label: "Partner di imprese e stabilimenti" },
        { value: "Nord & Centro", label: "Copertura operativa in Italia" },
        { value: "24h", label: "Risposta alle richieste di preventivo" },
      ],
      caption: "Squadre in opera · Posa armature",
      imgAlt: "Squadra operativa Forte Servizii al lavoro sulle armature in cantiere",
    },
    services: {
      overline: "I Nostri Servizi",
      title: "Quattro specializzazioni, un unico standard",
      desc: "Ogni servizio è erogato con personale proprio, procedure di sicurezza rigorose e piena integrazione con le vostre lavorazioni.",
      cta: "Richiedi disponibilità",
      items: [
        {
          title: "Carpenteria Edile ed Industriale",
          desc: "Realizzazione e montaggio di casseforme e strutture di carpenteria per opere edili e industriali, con squadre specializzate.",
          points: ["Casseforme e strutture", "Montaggio diretto in cantiere", "Carpentieri qualificati"],
          alt: "Carpenteria edile: casseforme in legno e armatura di un solaio in cantiere",
        },
        {
          title: "Posa del Ferro per Cemento Armato",
          desc: "Preparazione e posa in opera di armature per cemento armato, con ferraioli esperti e precisione millimetrica.",
          points: ["Armature a regola d'arte", "Ferraioli esperti", "Precisione di posa garantita"],
          alt: "Posa del ferro: gabbie di armatura per cemento armato in scavo",
        },
        {
          title: "Manovalanza Qualificata e Supporto Operativo",
          desc: "Personale selezionato e formato per supportare le attività di cantiere: squadre coese, autonome e immediatamente operative.",
          points: ["Personale selezionato", "Squadre autonome e coese", "Integrazione nei vostri processi"],
          alt: "Squadra di operai qualificati al lavoro su armatura di platea",
        },
        {
          title: "Outsourcing per Stabilimenti di Prefabbricazione",
          desc: "Servizi in outsourcing per stabilimenti di prefabbricazione: supporto continuativo alla produzione con organico scalabile.",
          points: ["Supporto alla produzione", "Organico scalabile sui picchi", "Presenza continuativa in stabilimento"],
          alt: "Gabbia di armatura per elemento prefabbricato in piazzale",
        },
      ],
    },
    strengths: {
      overline: "Perché Sceglierci",
      title: "Quattro garanzie, zero sorprese",
      ribbonLabel: "Standard operativi",
      items: [
        {
          title: "Massima Sicurezza in Cantiere",
          desc: "DPI completi, procedure rigorose e formazione continua. Per noi la sicurezza non è negoziabile.",
        },
        {
          title: "Personale Selezionato e Formato",
          desc: "Carpentieri e ferraioli esperti, squadre coese pronte a integrarsi nei vostri processi produttivi.",
        },
        {
          title: "Flessibilità Operativa",
          desc: "Organico scalabile per picchi produttivi, commesse urgenti e fabbisogni variabili di cantiere.",
        },
        {
          title: "Rispetto dei Tempi di Consegna",
          desc: "Pianifichiamo con i vostri direttori di cantiere e manteniamo gli impegni sul cronoprogramma.",
        },
      ],
      compliance: ["D.Lgs 81/08", "Regolarità DURC", "Assicurazione RCT / RCO", "Formazione continua sulla sicurezza"],
    },
    contact: {
      overline: "Contatti",
      title: "Richiedi un preventivo",
      desc: "Tariffe, disponibilità e preventivi per cantieri e stabilimenti: scriveteci e risponderemo entro 24 ore lavorative.",
      labels: {
        ragioneSociale: "Ragione Sociale",
        sedeLegale: "Sede Legale",
        email: "Email",
        telefono: "Telefono",
        nome: "Nome e Cognome *",
        azienda: "Azienda / Ragione Sociale *",
        servizio: "Tipo di Servizio Richiesto *",
        messaggio: "Messaggio / Specifiche di Cantiere *",
      },
      placeholders: {
        nome: "Mario Rossi",
        azienda: "Costruzioni Esempio SpA",
        email: "ufficio@azienda.it",
        telefono: "+39 ...",
        messaggio: "Descrivete la commessa: tipologia di lavorazione, periodo, numero di operatori richiesti...",
      },
      selectPlaceholder: "Seleziona un servizio",
      serviceOptions: [
        { value: "Carpenteria Edile ed Industriale", label: "Carpenteria Edile ed Industriale" },
        { value: "Posa del Ferro per Cemento Armato", label: "Posa del Ferro per Cemento Armato" },
        { value: "Manovalanza Qualificata e Supporto Operativo", label: "Manovalanza Qualificata e Supporto Operativo" },
        { value: "Outsourcing per Stabilimenti di Prefabbricazione", label: "Outsourcing per Stabilimenti di Prefabbricazione" },
        { value: "Altro", label: "Altro" },
      ],
      certTitle: "Certificazioni e Standard",
      certifications: ["Conformità D.Lgs 81/08", "Regolarità DURC", "Assicurazione RCT / RCO", "Formazione continua sulla sicurezza"],
      responsePre: "Risposta garantita entro",
      responseStrong: "24 ore lavorative",
      submit: "Invia Richiesta",
      sending: "Invio in corso...",
      successMsg: "Richiesta inviata con successo. Vi ricontatteremo entro 24 ore lavorative.",
      errorMsg: "Invio non riuscito. Riprova tra poco o contattaci telefonicamente.",
      toastSuccess: "Richiesta inviata con successo",
      toastError: "Invio non riuscito. Riprova tra poco.",
    },
    footer: {
      blurb: "Partner affidabile per l'edilizia e la prefabbricazione: carpenteria, posa del ferro e manovalanza qualificata per imprese e stabilimenti.",
      navTitle: "Navigazione",
      contactTitle: "Contatti diretti",
      rights: "Tutti i diritti riservati",
      standards: "D.Lgs 81/08 · DURC · RCT/RCO",
    },
  },
  en: {
    meta: {
      title: "Forte Servizii SRLS | Trusted Partner for Construction & Prefabrication",
    },
    nav: {
      tagline: "SRLS · CONSTRUCTION",
      status: "Site operations active",
      quote: "Get a Quote",
      quoteMobile: "Request a Quote",
      links: [
        { id: "#chi-siamo", label: "About Us", testid: "nav-link-chi-siamo" },
        { id: "#servizi", label: "Services", testid: "nav-link-servizi" },
        { id: "#perche-sceglierci", label: "Why Us", testid: "nav-link-perche-sceglierci" },
        { id: "#contatti", label: "Contact", testid: "nav-link-contatti" },
      ],
    },
    hero: {
      badge: "SPECIALIZED CONSTRUCTION COMPANY · B2B",
      lines: [
        { before: "", accent: "Trusted", after: " Partner" },
        { before: "for Construction", accent: "", after: "" },
        { before: "& Prefabrication", accent: "", after: "" },
      ],
      subtitle:
        "Reliability, on-the-job safety and a skilled workforce: we support general contractors, construction companies and precast plants with specialized operating crews.",
      ctaQuote: "Request a Quote",
      ctaContact: "Contact Us",
      stats: [
        { value: "D.Lgs 81/08", label: "Full safety compliance" },
        { value: "B2B", label: "Exclusive focus on contractors" },
        { value: "< 24h", label: "Quote response time" },
      ],
      scrollAria: "Scroll to the About section",
      imgAlt: "Reinforced concrete tunnel reinforcement built by Forte Servizii",
    },
    marquee: {
      items: [
        "Structural Carpentry",
        "Reinforced Concrete Rebar",
        "Prefabrication Outsourcing",
        "Specialized Workforce",
        "Certified Safety",
        "Guaranteed Delivery Times",
      ],
    },
    about: {
      overline: "About Us",
      title: "Operational strength, a job-site mindset",
      p1: "is a solid, dynamic and flexible company, specialized in operational support for construction sites and production plants. We work side by side with general contractors and construction companies, integrating into their processes and optimizing work schedules.",
      p2: "From carpentry to rebar installation, every job is carried out by selected and trained personnel, with absolute attention to safety and to the agreed work schedules.",
      stats: [
        { value: "100%", label: "Compliance with safety regulations" },
        { value: "B2B", label: "Partner to contractors and plants" },
        { value: "North & Central", label: "Operating coverage in Italy" },
        { value: "24h", label: "Response to quote requests" },
      ],
      caption: "Crews at work · Rebar installation",
      imgAlt: "Forte Servizii crew at work on site reinforcement",
    },
    services: {
      overline: "Our Services",
      title: "Four specializations, one standard",
      desc: "Every service is delivered with our own personnel, rigorous safety procedures and full integration with your operations.",
      cta: "Check availability",
      items: [
        {
          title: "Building & Industrial Carpentry",
          desc: "Construction and assembly of formwork and carpentry structures for building and industrial works, with specialized crews.",
          points: ["Formwork and structures", "Direct on-site assembly", "Qualified carpenters"],
          alt: "Building carpentry: timber formwork and slab reinforcement on site",
        },
        {
          title: "Rebar Installation for Reinforced Concrete",
          desc: "Preparation and installation of reinforcement for reinforced concrete, by expert steel fixers with millimetric precision.",
          points: ["Reinforcement built to spec", "Expert steel fixers", "Guaranteed installation precision"],
          alt: "Rebar installation: reinforcement cages for reinforced concrete",
        },
        {
          title: "Skilled Workforce & Operational Support",
          desc: "Selected and trained personnel to support your job-site activities: cohesive, autonomous crews, immediately operational.",
          points: ["Selected personnel", "Autonomous, cohesive crews", "Integration into your processes"],
          alt: "Skilled crew at work on a foundation slab reinforcement",
        },
        {
          title: "Outsourcing for Precast Plants",
          desc: "Outsourced services for precast plants: ongoing production support with a scalable workforce.",
          points: ["Production support", "Workforce scalable for peaks", "Continuous presence in your plant"],
          alt: "Reinforcement cage for precast elements in the plant yard",
        },
      ],
    },
    strengths: {
      overline: "Why Choose Us",
      title: "Four guarantees, zero surprises",
      ribbonLabel: "Operating standards",
      items: [
        {
          title: "Maximum On-Site Safety",
          desc: "Full PPE, rigorous procedures and ongoing training. For us, safety is non-negotiable.",
        },
        {
          title: "Selected & Trained Personnel",
          desc: "Expert carpenters and steel fixers — cohesive crews ready to integrate into your production processes.",
        },
        {
          title: "Operational Flexibility",
          desc: "A scalable workforce for production peaks, urgent contracts and changing site requirements.",
        },
        {
          title: "On-Time Delivery",
          desc: "We plan with your site managers and keep our commitments on the work schedule.",
        },
      ],
      compliance: ["D.Lgs 81/08", "DURC compliance", "RCT / RCO insurance", "Ongoing safety training"],
    },
    contact: {
      overline: "Contact",
      title: "Request a Quote",
      desc: "Rates, availability and quotes for job sites and plants: write to us and we will reply within 24 business hours.",
      labels: {
        ragioneSociale: "Company Name",
        sedeLegale: "Registered Office",
        email: "Email",
        telefono: "Phone",
        nome: "Full Name *",
        azienda: "Company / Business Name *",
        servizio: "Service Required *",
        messaggio: "Message / Job-Site Details *",
      },
      placeholders: {
        nome: "John Smith",
        azienda: "Example Construction Inc.",
        email: "office@company.com",
        telefono: "+39 ...",
        messaggio: "Describe the job: type of work, timeframe, number of workers needed...",
      },
      selectPlaceholder: "Select a service",
      serviceOptions: [
        { value: "Carpenteria Edile ed Industriale", label: "Building & Industrial Carpentry" },
        { value: "Posa del Ferro per Cemento Armato", label: "Rebar Installation for Reinforced Concrete" },
        { value: "Manovalanza Qualificata e Supporto Operativo", label: "Skilled Workforce & Operational Support" },
        { value: "Outsourcing per Stabilimenti di Prefabbricazione", label: "Outsourcing for Precast Plants" },
        { value: "Altro", label: "Other" },
      ],
      certTitle: "Certifications & Standards",
      certifications: ["D.Lgs 81/08 compliance", "DURC compliance", "RCT / RCO insurance", "Ongoing safety training"],
      responsePre: "Guaranteed response within",
      responseStrong: "24 business hours",
      submit: "Send Request",
      sending: "Sending...",
      successMsg: "Request sent successfully. We will get back to you within 24 business hours.",
      errorMsg: "Sending failed. Please try again shortly or contact us by phone.",
      toastSuccess: "Request sent successfully",
      toastError: "Sending failed. Please try again.",
    },
    footer: {
      blurb: "A trusted partner for construction and prefabrication: carpentry, rebar installation and skilled workforce for contractors and plants.",
      navTitle: "Navigation",
      contactTitle: "Direct Contact",
      rights: "All rights reserved",
      standards: "D.Lgs 81/08 · DURC · RCT/RCO",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("forte-lang") || "it";
    } catch {
      return "it";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("forte-lang", lang);
    } catch {
      /* storage unavailable */
    }
    document.documentElement.lang = lang;
    document.title = translations[lang].meta.title;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
